var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Editor, Element, Transforms } from "slate";
import { isBlockActive } from "./isBlockActive";
import { wrapLink } from "./wrapLink";
import { unwrapLink } from "./unwrapLink";
import { insertImage } from "./insertImage";
import { insertIframe } from "./insertIframe";
import { insertVideo } from "./insertVideo";
import { insertTable } from "./insertTable";
import { insertHorizontal } from "./insertHorizontal";
import { addAnchor } from "../helpers/insertAnchor";
var LIST_TYPES = ["numbered-list", "bulleted-list"];
// const TEXT_ALIGN_TYPES = ["left", "center", "right", "justify"];
var TEXT_ALIGN_TYPES = ["center", "right"];
export var toggleBlock = function (editor, format, url, callback, row, column) {
    if (url === void 0) { url = "https://www.google.com.tw/"; }
    return __awaiter(void 0, void 0, void 0, function () {
        var isActive, isList, newProperties, selection, _a, match, newAlign, oldAlign_1, oldAlignIdx, hiddenInput_1, fileReader_1, isHeadingOneActive, isHeadingTwoActive, newId, newId, format_type, block;
        return __generator(this, function (_b) {
            isActive = isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? "align" : "type");
            isList = LIST_TYPES.includes(format);
            Transforms.unwrapNodes(editor, {
                match: function (n) {
                    return !Editor.isEditor(n) &&
                        Element.isElement(n) &&
                        LIST_TYPES.includes(n.type) &&
                        !TEXT_ALIGN_TYPES.includes(format);
                },
                split: true,
            });
            if (TEXT_ALIGN_TYPES.includes(format)) {
                selection = editor.selection;
                _a = __read(Array.from(Editor.nodes(editor, {
                    at: Editor.unhangRange(editor, selection),
                    match: function (n) {
                        return (!Editor.isEditor(n) &&
                            Element.isElement(n) &&
                            TEXT_ALIGN_TYPES.includes(n["align"]));
                    },
                })), 1), match = _a[0];
                newAlign = void 0;
                if (!match) {
                    newAlign = TEXT_ALIGN_TYPES[0];
                }
                else {
                    oldAlign_1 = match[0].align;
                    oldAlignIdx = TEXT_ALIGN_TYPES.findIndex(function (el) { return el === oldAlign_1; });
                    newAlign =
                        oldAlignIdx + 1 !== TEXT_ALIGN_TYPES.length
                            ? TEXT_ALIGN_TYPES[oldAlignIdx + 1]
                            : undefined;
                }
                newProperties = {
                    align: newAlign,
                };
            }
            else if (format === "link") {
                if (editor.selection) {
                    wrapLink(editor, url);
                }
            }
            else if (format === "link_off") {
                if (isBlockActive(editor, "link")) {
                    unwrapLink(editor);
                }
            }
            else if (format === "image") {
                hiddenInput_1 = document.createElement("input");
                fileReader_1 = new FileReader();
                hiddenInput_1.type = "file";
                hiddenInput_1.addEventListener("change", function () { return __awaiter(void 0, void 0, void 0, function () {
                    var curFile, ImageFile;
                    return __generator(this, function (_a) {
                        curFile = hiddenInput_1.files;
                        ImageFile = curFile[0];
                        fileReader_1.readAsDataURL(ImageFile);
                        return [2 /*return*/];
                    });
                }); });
                fileReader_1.addEventListener("load", function (event) {
                    var _a;
                    var base64DataUrl = (_a = event.target) === null || _a === void 0 ? void 0 : _a.result;
                    insertImage(editor, base64DataUrl);
                });
                hiddenInput_1.click();
            }
            else if (format === "horizontal") {
                insertHorizontal(editor);
            }
            else if (format === "unsplash") {
                // insertUnsplash(editor, url);
            }
            else if (format === "video") {
                insertVideo(editor, url);
            }
            else if (format === "embed") {
                insertIframe(editor, url);
            }
            else if (format === "table") {
                insertTable(editor, row, column);
            }
            else if (format === "sub-title") {
                isHeadingOneActive = isBlockActive(editor, "heading-one", TEXT_ALIGN_TYPES.includes(format) ? "align" : "type");
                isHeadingTwoActive = isBlockActive(editor, "heading-two", TEXT_ALIGN_TYPES.includes(format) ? "align" : "type");
                if (!isHeadingOneActive && !isHeadingTwoActive) {
                    newId = Math.random().toString();
                    addAnchor({
                        anchorData: { editor: editor, id: newId, type: "heading-one" },
                        anchorOperations: {
                            addToList: callback[0],
                            removeFromList: callback[1],
                        },
                    });
                    newProperties = {
                        type: "heading-one",
                        id: newId,
                    };
                }
                else if (isHeadingOneActive && !isHeadingTwoActive) {
                    newId = Math.random().toString();
                    addAnchor({
                        anchorData: { editor: editor, id: newId, type: "heading-two" },
                        anchorOperations: {
                            addToList: callback[0],
                            removeFromList: callback[1],
                        },
                    });
                    newProperties = {
                        type: "heading-two",
                        id: newId,
                    };
                }
                else {
                    addAnchor({
                        anchorData: { editor: editor, id: "", type: "" },
                        anchorOperations: {
                            addToList: callback[0],
                            removeFromList: callback[1],
                        },
                    });
                    newProperties = {
                        type: "paragraph",
                        id: null,
                    };
                }
            }
            else {
                format_type = format;
                newProperties = {
                    type: isActive ? "paragraph" : isList ? "list-item" : format_type,
                    id: null,
                };
            }
            Transforms.setNodes(editor, newProperties);
            if (!isActive && isList) {
                block = {
                    type: format,
                    children: [],
                };
                Transforms.wrapNodes(editor, block);
            }
            return [2 /*return*/];
        });
    });
};
